import { Box } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

type ContainerProps = {
  isAI: boolean;
  messageIndex: number;
};

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI" && prop !== "messageIndex"
})(({ isAI, messageIndex }: ContainerProps) => ({
  display: "flex",
  flexDirection: isAI ? "row" : "row-reverse",
  alignItems: "end",
  width: "100%",
  paddingLeft: "5px",
  paddingRight: "5px",
  marginTop: messageIndex === 0 ? "auto" : 0
}));

type AvatarContainerProps = {
  theme: Theme;
  isAI: boolean;
};

export const AvatarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI"
})(({ theme, isAI }: AvatarContainerProps) => ({
  borderRadius: 999,
  flexShrink: 0,
  border: `1px solid ${isAI ? theme.customColors.accentVariantB : "transparent"}`,
  marginBottom: "5px",
  width: "37px",
  height: "37px"
}));

type MessageContainerProps = {
  theme: Theme;
  isAI: boolean;
};

export const MessageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI"
})(({ theme, isAI }: MessageContainerProps) => ({
  backgroundColor: theme.customColors.backgroundPrimary,
  borderRadius: "10px",
  borderLeft: `2px solid ${isAI ? theme.customColors.accentVariantB : "transparent"}`,
  borderRight: `2px solid ${isAI ? "transparent" : theme.customColors.accentVariantB}`,
  textAlign: `${isAI ? "left" : "right"}`,
  paddingLeft: "30px",
  paddingRight: "30px",
  paddingTop: "10px",
  paddingBottom: "10px",
  maxWidth: "80%",
  display: "flex"
}));

export const MessageBox = styled(Box)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "14px",
  animation: "blink 0.5s steps(2, start) infinite",
  "@keyframes blink": {
    "50%": { borderRightColor: "transparent" }
  },
  "> p": {
    margin: 0
  }
}));
